var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnitem",on:{"click":_vm.toChat}},[_c('img',{staticStyle:{"width":"19px","height":"19px"},attrs:{"src":require("@/assets/linshiyonggong/kefu@2x.png")}}),_c('span',[_vm._v("交流")])])
}
var staticRenderFns = []

export { render, staticRenderFns }